import { domainUrl } from '../constants';

export const API_CUSTOMER_FEEDBACK = `${domainUrl}customer/feedbacks`;
export const API_CUSTOMER_FEEDBACK_SOLVED = `${domainUrl}customer/feedbacks/solved`;
